import { Link } from 'react-router-dom'
import newsroomImg from './assets/dev/newspaper-reader.jpg'

const RAIL_LINKS = [
  {
    to: '/admin/dev-status',
    label: 'Development Status',
    description: 'Platform build state across UI and API layers',
  },
  {
    to: '/admin/layouts',
    label: 'Layout Studio',
    description: 'Create and manage page layouts',

  },
  {
    to: '/admin/pages',
    label: 'Production Desk',
    description: 'Build and preview editorial pages',
  },
  {
    to: '/admin/articles',
    label: 'Article Manager',
    description: 'Review and preview contract-driven articles',
  },
  {
    to: '/admin/design-guide',
    label: 'Design Guide',
    description: 'Component library and design tokens',
  },
]

function WireMockup() {
  return (
    <div className="max-w-[1400px] mx-auto px-8 py-8">
      <div className="grid grid-cols-[2fr_1fr_1fr] divide-x divide-line">

        {/* Feature column */}
        <div className="px-5 pb-5">
          {/* Feature image */}
          <img src={newsroomImg} alt="" className="mb-4 aspect-video w-full object-cover" />
          <p className="mb-1 font-sans text-[10px] font-semibold uppercase tracking-widest text-fg-secondary">
            (U//FOUO) Platform Update
          </p>
          <h2 className="font-zodiak text-2xl font-bold leading-tight text-fg">
            <span className="font-normal text-fg-secondary">(U)</span>{' '}WIRe Homepage Launching Soon
          </h2>
          <p className="mt-3 font-sans text-sm leading-relaxed text-fg-secondary">
            (U) The front page of WIRe will appear here — delivering live editorial pages built and
            curated by the WIRe editorial team. It will be available once the admin and editorial
            screens are sufficiently far along.
          </p>
          <div className="mt-4 font-sans text-[10px] uppercase tracking-wide text-fg-secondary">
            {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </div>
        </div>

        {/* Rail */}
        <div className="col-span-2 divide-y divide-line">
          <div className="bg-fg px-4 py-2">
            <span className="font-sans text-[10px] font-semibold uppercase tracking-widest text-canvas">
              What's Available Now
            </span>
          </div>
          {RAIL_LINKS.map(({ to, label, description }) => (
            <Link key={to} to={to} className="group flex flex-col gap-1 p-4 hover:bg-canvas-subtle transition-colors">
              <span className="font-zodiak text-sm font-bold leading-snug text-fg group-hover:text-accent-primary-fg transition-colors">
                {label}
              </span>
              <span className="font-sans text-[11px] text-fg-secondary">{description}</span>
            </Link>
          ))}
        </div>

      </div>

    </div>
  )
}

export default WireMockup
